import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(10),
    marginLeft: theme.spacing(10),
  },
  row: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'baseline',
    justifyContent: 'center',
    flex: 1,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  specificRow: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  fieldRow: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'start',
    justifyContent: 'center',
    flex: 1,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  inputSubjectContainer: {
    display: 'flex',
    flexBasis: '42%',
    justifyContent: 'flex-end',
    marginRight: theme.spacing(3),
  },
  fieldLabelContainer: {
    display: 'flex',
    flexBasis: '42%',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(3),
  },
  inputSubjectLabel: {
    display: 'flex',
    textAlign: 'end',
  },
  inputContainer: {
    marginLeft: theme.spacing(3),
    flexBasis: '58%',
    display: 'flex',
  },
  footer: {
    marginTop: theme.spacing(10),
  },
  circularProgress: {
    color: theme.palette.primary.contrastText,
  },
  selectedStatistic: {
    fontWeight: 'bold',
  },
}));
